/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_TitleInputs */



/**
* | output |
* | --- |
* | "Visual Watermark" |
*
* @param {Options_Watermark_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_title = /** @type {((inputs?: Options_Watermark_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filigrane visuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Visuelles Wasserzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filigrana visiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Визуальный водяной знак")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marca de agua visual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("可视水印")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビジュアルウォーターマーク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज़ुअल वॉटरमार्क")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marca de água visual")
	return /** @type {LocalizedString} */ ("Visual Watermark")
});